import { render, staticRenderFns } from "./login-manage.vue?vue&type=template&id=6d462e54&"
import script from "./login-manage.vue?vue&type=script&lang=js&"
export * from "./login-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports